import { CommonAuthorizationService } from '@savgroup-front-common/core/api/Authorization/AuthorizationService';

import {
  deleteApiApplication,
  getApiApplication,
  setApiApplication,
  updateApiApplication,
} from './apiCredentials';
import { getAssignablePermissionsQuery } from './getAssignablePermissionsQuery';
import getFeatureFlagsByIdQuery from './getFeatureFlagsByIdQuery';
import getUserInformationByIdQuery from './getUserInformationByIdQuery';
import getUserInformationByIdsQuery from './getUserInformationByIdsQuery';
import getUsersInformationBySellerIdQuery from './getUsersInformationBySellerIdQuery';
import inviteUserCommand from './inviteUserCommand';
import listManagementUsersQuery from './listManagementUsersQuery';
import listUserSiteQuery from './listUserSiteQuery';
import login from './login';
import { getConfigurableRolesQuery } from './roles/getConfigurableRolesQuery';
import upsertFeatureFlagsCommand from './upsertFeatureFlagsCommand';
import { deleteUserProfileCommand } from './user/deleteUserProfileCommand';
import { listUserProfileQuery } from './user/listUserProfileQuery';
import setUserProfilesToUser from './user/setUserProfilesToUser';
import { unlinkUserFromSellerCommand } from './user/unlinkUserFromSellerCommand';
import { upsertUserProfileCommand } from './user/upsertUserProfileCommand';
import upsertUserManagementCommand from './user/upsertUserManagementCommand';

const AuthorizationService = {
  listManagementUsersQuery,
  getUserInformationByIdQuery,
  getUserInformationByIdsQuery,
  listUserSiteQuery,
  getUsersInformationBySellerIdQuery,
  upsertFeatureFlagsCommand,
  setApiApplication,
  deleteApiApplication,
  updateApiApplication,
  getApiApplication,
  setUser: upsertUserManagementCommand,
  upsertUserManagementCommand,
  setUserProfilesToUser,
  login,
  getFeatureFlagsQuery: CommonAuthorizationService.getFeatureFlagsQuery,
  getFeatureFlagsByIdQuery,
  inviteUserCommand,
  getConfigurableRolesQuery,
  listUserProfileQuery,
  upsertUserProfileCommand,
  deleteUserProfileCommand,
  getAssignablePermissionsQuery,

  pagedListManagementUsersQuery:
    CommonAuthorizationService.pagedListManagementUsersQuery,
  unlinkUserFromSellerCommand,
};

export default AuthorizationService;
